import { render, staticRenderFns } from "./BaseSelectNew.vue?vue&type=template&id=b2cbea0a&scoped=true"
import script from "./BaseSelectNew.vue?vue&type=script&lang=js"
export * from "./BaseSelectNew.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectNew.vue?vue&type=style&index=0&id=b2cbea0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cbea0a",
  null
  
)

export default component.exports